var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.carbonPrefix}--snippet ${_vm.carbonPrefix}--skeleton ${_vm.carbonPrefix}--snippet--${_vm.multi ? 'multi' : 'single'}`},[_c('div',{class:`${_vm.carbonPrefix}--snippet-container`},[_c('span'),(_vm.multi)?_c('span'):_vm._e(),(_vm.multi)?_c('span'):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }